export default __webpack_public_path__ + "static/media/home_bg.47eea97d.png";